import { render, staticRenderFns } from "./salemanList.vue?vue&type=template&id=473c3e54&scoped=true"
import script from "./salemanList.vue?vue&type=script&lang=js"
export * from "./salemanList.vue?vue&type=script&lang=js"
import style0 from "./salemanList.vue?vue&type=style&index=0&id=473c3e54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473c3e54",
  null
  
)

export default component.exports